import '../App.scss';
import React, { useState, Component } from 'react';
import TopBarAlt from '../components/Organisms/TopBarAlt'
import NavBar from '../components/Molecules/NavBar'
import CategoryButtons from '../components/Molecules/CategoryButtons';


// // Import css files
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";



function Menu() {


  return (
    <div style={{height: '101vh'}}>
      <TopBarAlt open={true}/>
      <CategoryButtons fullWidth={true}/>
      <NavBar fullWidth={true}/>
    </div>

    





  );
}

export default Menu;
